export interface ExperimentalFeatureDef {
  id: string;
  label: string;
  description: string;
}

export const EXPERIMENTAL_FEATURES: ExperimentalFeatureDef[] = [
  {
    id: "financial_modelling",
    label: "Financial Modelling",
    description: "Advanced tools for financial forecasting, revenue projections, and scenario analysis directly within your dashboard.",
  },
  {
    id: "prospo_agent",
    label: "Prospo Agent",
    description: "AI-powered autonomous agent for proactive prospecting, lead enrichment, and automated outreach sequencing.",
  },
  {
    id: "documents",
    label: "Documents",
    description: "Create, edit and manage documents and templates (proposals, MSAs, work orders) with linked client/contact data, versioning and PDF export.",
  },
  {
    id: "revenue_billing",
    label: "Revenue and Billing",
    description: "Track practice income (brokerage & commission statements) and expenses (invoices & bills), with ABN-enriched Company client creation from providers and vendors.",
  },
];

export const hasExperimentalFeature = (loginData: any, featureId: string): boolean => {
  if (!loginData) return false;
  return (loginData.experimentalFeatures ?? []).includes(featureId);
};